import React, { useState } from 'react';
import { Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import logoTC from './../../images/Logo Tsahal Conection.png';
import logoAchGadol from './../../images/logos/AchGadol.png';
import Meitav from './../../images/logos/Meitav.png';
import Atuda from './../../images/logos/Atuda.png';
import Mahatz from './../../images/logos/Mahatz.png';
import Aluma from './../../images/logos/Aluma.png';
import Atidim from './../../images/logos/Atidim.png';
import MokedBodedim from './../../images/logos/MokedBodedim.png';
import GarinTzabar from './../../images/logos/GarinTzabar.png';
import CNEF from './../../images/logos/CNEF.png';
import NefeshBeNefesh from './../../images/logos/nefeshBeNefesh.png';
import { FORM_LINKS } from '../../constants/Links';

export default function FormulaireStatic() {
const cardData = [
        {   

            title: 'Raphael Madar, Directeur de Tsahal Connection',
            text:  (
                <div>
                    <p><strong>Tel -</strong> 054-9056016</p>
                    <p><strong>Mail -</strong> info@tsahalco.com</p>
                    <p><strong>WhatsApp - </strong> +972-549056016 (Gratuit)</p>
                    <p><strong>Site - </strong><Link to="/" target="_blank" style={{color: 'black'}}>www.tsahalco.com</Link></p>
                </div>
            ),
            image: logoTC
        },
        {
            title: 'Association Ach Gadol pour les soldats seuls',
            text:  (
                <div>
                    <p><strong>Mail -</strong> info@achgadol.org</p>
                    <p><strong>Site - </strong> <Link to="www.achgadol.org" target="_blank" style={{color: 'black'}}>www.achgadol.org</Link></p>
                    <p><strong>Whatsapp -</strong> +972-58-685-3497</p>
                </div>
            ),            
            image: logoAchGadol
        },
        {
            title:'Unité Meitav',
            text:  (
                <div>
                    <p><strong>Tel (depuis Israel)-</strong> 1111</p>
                    <p><strong>WhatsApp (depuis Europe en hébreu OU anglais)- </strong> +33 6 50 76 40 05</p>
                    <p><strong>Mail -</strong> meitav@digital.idf.il</p>
                    <p><strong>Mail (depuis Europe en hébreu OU anglais)- </strong> meitav@paris.mfa.gov.il</p>
                    <p><strong>Site - </strong><Link to="https://www.mitgaisim.idf.il/ " target="_blank" style={{color: 'black'}}>https://www.mitgaisim.idf.il</Link></p>
                </div>
            ),            
            image: Meitav
        },
        {
            title: "Unité Meitav en charge des Olims (Alyah apres 16 ans)",
            text:  (
                <div>
                    <p><strong>Tel -</strong> 03-738-7080</p>
                    <p><strong>Mail -</strong> joinidf@digital.idf.il (possibilité d’écrire en français).</p>
                    <p><strong>WhatsApp - </strong> +972-529458579.</p>
                </div>
            ),   
            image: Meitav
        },
        {
            title: "Branche Atouda",
            text:  (
                <div>
                    <p><strong>Tel -</strong> 03-7387058</p>
                    <p><strong>Mail -</strong> atudaAcademit@gmail.com</p>
                    <p><strong>Site - </strong> <Link style={{color: 'black'}} to="https://www.atuda.org.il" target="_blank">https://www.atuda.org.il</Link></p>
                </div>
            ),   
            image: Atuda
        },
        {
            title: "Branche Haredi pour garçon",
            text:  (
                <div>
                    <p><strong>Tel -</strong> *9779</p>
                    <p><strong>Site - </strong> <Link style={{color: 'black'}} to="https://9779.mod.gov.il/" target="_blank">https://9779.mod.gov.il</Link></p>
                </div>
            ),              
            image: Mahatz
        },
        {
            title: "Aluma (Filles religieuses)",
            text:  (
                <div>
                    <p><strong>Site - </strong> <Link style={{color: 'black'}} to= "www.aluma.org.il" target="_blank">www.aluma.org.il</Link></p>
                    <p><strong>Centre Beit Hel dans Meitav -</strong> 052-4767252</p>
                </div> 
                ),
            image: Aluma
        },
        {
            title: "Atidim",
            text:  (
                <div>
                    <p><strong>Mail -</strong> info@atidim.org</p>
                </div>
            ),   
            image: Atidim
        },
        {
            title: "Centre d'appel pour les soldats seuls (Moked Bodedim)",
            text:  (
                <div>
                    <p><strong>Tel -</strong> 03-7375200</p>
                    <p><strong>Tel (depuis l'étranger) -</strong> +972-3-5691000</p>
                    <p><strong>WhatsApp -</strong> 052-9437725</p>
                </div>
            ),   
            image: MokedBodedim
        },
        {
            title: "Programme Garin Tzabar",
            text:  (
                <div>
                    <p><strong>Site - </strong> <Link style={{color: 'black'}} to= "https://garintzabar.org/ " target="_blank">https://garintzabar.org/</Link></p>
                </div>
            ),   
            image: GarinTzabar
        },
        {
            title: "Association francophones du CNEF",
            text:  (
                <div>
                    <p><strong>Tel -</strong> 02-6222625.</p>
                    <p><strong>Mail -</strong> info@cnef.org. </p>
                    <p><strong>WhatsApp - </strong> +972-584222526</p>
                    <p><strong>Site - </strong><Link to="https://www.cnef.org" target="_blank" style={{color: 'black'}}>https://www.cnef.org</Link></p>
                </div>
            ),  
            image: CNEF
        },
        {
            title: "Programme Nefesh BeNefesh pour les soldats seuls - partie francophone",
            text:  (
                <div>
                    <p><strong>Tel -</strong> 054-707-8090</p>
                    <p><strong>Hotline 24/7 - </strong> 1-8000-71400.</p>
                    <p><strong>Site - </strong><Link to="https://www.cnef.org" target="_blank" style={{color: 'black'}}> https://www.nbn.org.il/</Link></p>
                </div>
            ),
            image: NefeshBeNefesh
        }
    ];

    
const [cards, setCards] = useState(new Array(12).fill(false));

    const toggleCard = (index) => {
        const newCards = [...cards];
        newCards[index] = !newCards[index];
        setCards(newCards);
    };


const styles = `
    .hoverUnderline {
        color: #2f3036;
        text-decoration: none;
        transition: text-decoration 0.3s;
    }

    .hoverUnderline:hover {
        text-decoration: underline;
    }
`;


  return (
    <>
      <style>{styles}</style>
      <Container maxWidth="md" style={{marginTop: '3rem', marginBottom: '3rem'}}>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '34px', marginBottom: '2rem', fontWeight: '700' }}>
                              Documents
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '28px', marginBottom: '2rem', fontWeight: '600' }}>
                              Tsav Richon
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 Formulaire médical (<Link to={FORM_LINKS.FORMULAIRE_MEDICAL_TSAV1_ANGLAIS} target="_blank">anglais</Link> ou <Link to={FORM_LINKS.FORMULAIRE_MEDICAL_TSAV1_HEBREU} target="_blank">hébreu</Link>) avec <Link to={FORM_LINKS.EXPLICATION_FORMULAIRE_MEDICAL_TSAV1} target="_blank">document explicatif</Link>.
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '2rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.DEMANDE_ANNULATION_ANNEE_INTEGRATION} target="_blank">Demande pour annuler l’année d’intégration pour les nouveaux immigrants et avancer la date du Tsav Rishon.</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '28px', marginBottom: '2rem', fontWeight: '600' }}>
                              Mahal
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 Formulaire d'inscription à Mahal (Touriste/Zakai Alyah : <Link to={FORM_LINKS.MAHAL_FORMULAIRE_TOURISTE_ANGLAIS} target="_blank">anglais</Link> ou <Link to={FORM_LINKS.MAHAL_FORMULAIRE_TOURISTE_HEBREU} target="_blank">hébreu</Link> ; Ben Meager (israéliens) : <Link to={FORM_LINKS.MAHAL_FORMULAIRE_BEN_MEAGER_ANGLAIS} target="_blank">anglais</Link> ou <Link to={FORM_LINKS.MAHAL_FORMULAIRE_BEN_MEAGER_HEBREU} target="_blank">hébreu</Link>) - <Link to={FORM_LINKS.EXPLICATION_FORMULAIRE_MAHAL} target="_blank">Document explicatif</Link>.
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '2rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.MAHAL_CHECKLIST_DOCS} target="_blank">Check-List & documents à préparer</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '28px', marginBottom: '2rem', fontWeight: '600' }}>
                              Entretiens
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.DEMANDE_TEST_MODIIN} target="_blank">Demande d’entretiens pour la branche des renseignements (Modiin).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.FORMULAIRE_ATOUDA_AKADEMIT} target="_blank">Demande pour rejoindre le parcours Atouda Akademit (peut se faire en ligne).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.FORMULAIRE_ATOUDA_OLIM} target="_blank">Demande pour rejoindre le parcours Atouda Olim.</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.FORMULAIRE_MEDICAL_YOM_SAYAROT_GIBBUSHIM} target="_blank">Formulaire médical pour les différents tests physiques (Gibbush, Yom Sayerot etc..).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.MODELE_SAYAROT_GARCONS_2024} target="_blank">Modèle Sayerot 2024 (garçons).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '2rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.MODELE_SAYAROT_FILLES_2024} target="_blank">Modèle Sayerot 2024 (filles).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '28px', marginBottom: '2rem', fontWeight: '600' }}>
                              Cas spéciaux
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.FORMULAIRE_ENFANT_UNIQUE_HEBREU}    target="_blank">Formulaire de volontariat dans les unités combattantes pour enfant unique (en hébreu).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.FORMULAIRE_ENFANT_UNIQUE_ANGLAIS}    target="_blank">Formulaire de volontariat dans les unités combattantes pour enfant unique (en anglais).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '2rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.EXPLICATION_ENFANT_UNIQUE} target="_blank">Explication pour remplir le formulaire de volontariat dans les unités combattantes pour enfant unique (en français).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '28px', marginBottom: '2rem', fontWeight: '600' }}>
                              Préparations militaires - Mechinot Kdam Tsvaiot
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.MECHINOT_OFEK_6_MOIS}    target="_blank">Liste des préparations militaires de 6 mois (OFEK).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.MECHINOT_ANNUELLES}    target="_blank">Liste des préparations militaires annuelle (générales).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '2rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.MECHINOT_RELIGIEUSES}    target="_blank">Liste des préparations militaires annuelle (religieuses).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '28px', marginBottom: '2rem', fontWeight: '600' }}>
                              PGCD de Tsahal Connection:
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.PGCD_HEBREU} target="_blank">Version originale en hébreu.</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '2rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.PGCD_FRANCAIS} target="_blank">Version traduite en français.</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '28px', marginBottom: '2rem', fontWeight: '600' }}>
                              Droits et aides​
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '1rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.SOLDATS_SEULS_SALAIRES} target="_blank">Brochure des droits des soldats seuls en français (Mars 2024).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '20px', fontWeight: '500', color: '#2f3036', marginBottom: '2rem' }}>
                          🟣 <Link className="hoverUnderline" to={FORM_LINKS.AFFAIRES_GIYUS_CARTE_ETOILE} target="_blank">Liste d'affaire à préparer et reçue lors de l'enrôlement avec explications sur la carte étoile (Kohavim).</Link>   
                          </Typography>
                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '34px', marginBottom: '2rem', fontWeight: '700' }}>
                              Carnet d'adresses
                          </Typography>
                          <div style={{marginBottom: '4rem'}}>
                              {cardData.map((data, index) => (
                                  <div key={index} style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '1rem', marginBottom: '1rem' }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                      {data.image && (
                                      <img
                                          src={data.image}
                                          alt={`logo for ${data.title}`}
                                          style={{ width: '50px', height: '50px', marginRight: '1rem', borderRadius: '50%' }}
                                      />
                                  )}
                                          <Typography
                                              variant="body1"
                                              style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: '600', color: '#2f3036', textTransform: 'uppercase', marginTop: '0.5rem'}}
                                          >
                                              {data.title}
                                          </Typography>
                                          <div>
                                              <Button
                                                  variant="text"
                                                  onClick={() => toggleCard(index)}
                                                  style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: '500', color: '#2f3036', outline: 'none' }}
                                              >
                                                  {cards[index] ? '-' : '+'}
                                              </Button>
                                          </div>
                                      </div>
                                      {cards[index] && (
                                          <Typography variant="body1" style={{ fontFamily: 'Montserrat', lineHeight: '1.8', fontSize: '18px', marginTop: '1rem' }}>
                                              {data.text}
                                          </Typography>
                                      )}
                                  </div>
                              ))}
                              </div>                    
                      </Container>
    </>
  );
}
